module.exports = __webpack_public_path__ + "static/media/029.36a10521.jpg";